import { Dispatch } from 'redux'

import type {
  TCreateSavedDashboardFilterRequestBody,
  TSavedDashboardFilterDto,
  TUpdateSavedDashboardFilterRequestBody
} from '@homepal/api-contract'

import {
  create,
  destroy,
  getAll,
  update
} from 'redux/api/SavedDashboardFilters'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

export function tryGetAllSavedDashboardFilters() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

export function tryCreateSavedDashboardFilter(
  data: TCreateSavedDashboardFilterRequestBody,
  callback: (
    err: Error | null,
    resource: TSavedDashboardFilterDto | null
  ) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    create({ data })
      .then((response) => {
        dispatch(actions.createSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.FilterCreated))

        callback(null, response.data.data)
      })
      .catch((e) => {
        dispatch(actions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.FilterCreatedFailed))

        callback(e, null)
      })
  }
}

export function tryUpdateSavedDashboardFilter(
  id: string,
  data: TUpdateSavedDashboardFilterRequestBody,
  callback: (
    err: Error | null,
    resource: TSavedDashboardFilterDto | null
  ) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    update(id, { data })
      .then((response) => {
        dispatch(actions.updateSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.FilterUpdated))

        callback(null, response.data.data)
      })
      .catch((e) => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.FilterUpdatedFailed))

        callback(e, null)
      })
  }
}

export function tryDeleteSavedDashboardFilter(
  id: string,
  callback: (err?: Error) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    destroy(id)
      .then(() => {
        dispatch(actions.destroySuccess(id))

        dispatch(toggleSnackbarOpen(SnackbarMessage.FilterDeleted))

        callback()
      })
      .catch((err) => {
        dispatch(actions.destroyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.FilterDeletedFailed))

        callback(err)
      })
  }
}

export const useSavedDashboardFilterActions = () => {
  return {
    tryGetAllSavedDashboardFilters: useThunkActions(
      tryGetAllSavedDashboardFilters
    ),
    tryCreateSavedDashboardFilter: useThunkActions(
      tryCreateSavedDashboardFilter
    ),
    tryUpdateSavedDashboardFilter: useThunkActions(
      tryUpdateSavedDashboardFilter
    ),
    tryDeleteSavedDashboardFilter: useThunkActions(
      tryDeleteSavedDashboardFilter
    )
  }
}
